"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var createApp_native_exports = {};
__export(createApp_native_exports, {
  createApp: () => createApp
});
module.exports = __toCommonJS(createApp_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react_native = require("react-native");
var import_react = require("react");
var import_polyfills_mobile = require("./polyfills-mobile");
var import_Root = require("./Root");
var import_setup = require("./setup");
import_react_native.LogBox.ignoreLogs([
  /Sending .* with no listeners registered/
]);
function createApp(options) {
  var routes = options.routes;
  var routeVersion = 0;
  var routeListeners = /* @__PURE__ */ new Set();
  var subscribeToRoutes = function subscribeToRoutes2(listener) {
    routeListeners.add(listener);
    return function() {
      return routeListeners.delete(listener);
    };
  };
  var getRouteVersion = function getRouteVersion2() {
    return routeVersion;
  };
  globalThis.__VXRN_UPDATE_NATIVE_ROUTES__ = function(nextRoutes) {
    var _globalThis___vxrnresetState, _globalThis;
    routes = nextRoutes;
    globalThis["__vxrnVersion"] = (globalThis["__vxrnVersion"] || 0) + 1;
    (_globalThis___vxrnresetState = (_globalThis = globalThis)["__vxrnresetState"]) === null || _globalThis___vxrnresetState === void 0 ? void 0 : _globalThis___vxrnresetState.call(_globalThis);
    routeVersion++;
    routeListeners.forEach(function(listener) {
      return listener();
    });
  };
  var App = function App2() {
    (0, import_react.useSyncExternalStore)(subscribeToRoutes, getRouteVersion, getRouteVersion);
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Root.Root, {
      isClient: true,
      flags: options.flags,
      routes,
      routerRoot: options.routerRoot,
      linking: options.linking,
      path: "/"
    });
  };
  import_react_native.AppRegistry.registerComponent("main", function() {
    return App;
  });
  if (process.env.ONE_APP_NAME) {
    import_react_native.AppRegistry.registerComponent(process.env.ONE_APP_NAME, function() {
      return App;
    });
  }
}
//# sourceMappingURL=createApp.native.js.map
